<template lang="pug">
  .home
    TablaSolicitudInformacion
</template>

<script>
// @ is an alias to /src
import TablaSolicitudInformacion from "./TablaSolicitudInformacion";
export default {
  name: 'Home',
  components: {
    TablaSolicitudInformacion,
  }
}
</script>
